import React, {Suspense, useEffect, useState} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import BigNumber from 'bignumber.js';
import {useWeb3React} from "@web3-react/core";
import {useDispatch} from 'react-redux';
import GlobalStyle from './style/Global';
import PageLoader from './components/PageLoader';
import useEagerConnect from './hooks/useEagerConnect';
import Layout from './components/Layout';
import ResetStyle from './style/Reset';
import {fetchFarmUserDataAsync} from './state/farms';
import useRefresh from "./hooks/useRefresh";
import {fetchAnalytics, fetchBackendUserData, fetchBackendUserHistory, fetchPredictPools} from "./utils/fetchData";


// eslint-disable-next-line @typescript-eslint/no-unused-vars

// This config is required for number formating
BigNumber.config({
    EXPONENTIAL_AT: 1000,
    DECIMAL_PLACES: 80,
});

const App: React.FC = () => {
    // Monkey patch warn() because of web3 flood
    // To be removed when web3 1.3.5 is released
    useEffect(() => {
        console.warn = () => null;
    }, []);

    useEagerConnect();

    const {account} = useWeb3React();
    const dispatch = useDispatch();
    const {fastRefresh} = useRefresh();
    useEffect(() => {
        if (account) {
            dispatch(fetchFarmUserDataAsync(account));
        }
    }, [account, dispatch, fastRefresh]);

    const [analyticsList, setAnalyticsList] = useState([]);
    const [userPoolsData, setUserPoolsData] = useState({robotsInfo: []});
    const [predictedPools, setPredictedPools] = useState({predictableRobots: []});
    const [userHistory, setUserHistory] = useState({robotHistories: []});
    const [lastInterval, setLastInterval] = useState(null)

    useEffect(() => {
        const analyticsIntervalTimeout = 120000;
        fetchAnalytics(setAnalyticsList);
        setInterval(() => fetchAnalytics(setAnalyticsList), analyticsIntervalTimeout);
    }, []);

    useEffect(() => {
        const interval = 15000; // 15 seconds
        async function fetchData() {
            if (account) {
                await fetchBackendUserHistory(account, setUserHistory);
                await fetchBackendUserData(account, setUserPoolsData);
                await fetchPredictPools(account, setPredictedPools);
            }
        }
        if (account) {
            if(lastInterval){
                clearInterval(lastInterval)
            }
            fetchData();
            const int = setInterval(() => fetchData(), interval);
            setLastInterval(int)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account]);

    return (
        <Router>
            <ResetStyle/>
            <GlobalStyle/>
            <Suspense fallback={<PageLoader/>}>
                <Layout analyticsList={analyticsList} userPoolsData={userPoolsData} userHistory={userHistory}
                        setUserPoolsData={setUserPoolsData} predictedPools={predictedPools}/>
            </Suspense>
        </Router>
    );
};

export default React.memo(App);
